import * as z from "zod";

export const cartonDisplayIdentifiersSchema = z
  .array(
    z
      .string()
      .trim()
      .min(1)
      .max(64)
      .regex(/^[^\r\n\t]+$/),
  )
  .min(1)
  .max(100);

export function formatCartonDisplayIdentifier(issuedNumber: bigint): string {
  if (issuedNumber <= 0n) {
    throw new Error("Carton issued number must be positive");
  }
  return issuedNumber.toString().padStart(4, "0");
}
